import React, { useEffect, useState } from 'react';
import {
  Form, Row, Button, Space, Col, Select, Steps, Result, Typography
} from 'antd';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { CheckOutlined, StopOutlined, LoadingOutlined } from '@ant-design/icons';
import WoocommerceAPi from 'woocommerce';
import { saveRecipe } from 'utils/recipes';
import { saveSpecification } from 'utils/specifications';
import Spinner from '../../../components/Spins/Basic';

const { Step } = Steps;
const { Title } = Typography;

const CostingForm = props => {
  const {
    recipe, specification, filteredFlexibleFeatures, setFinalSpecifications
  } = props;
  // eslint-disable-next-line no-debugger
  const { history: { replace } } = props;
  const [newRecipeSaved, setNewRecipeSaved] = useState(false);
  const [productsFetched, setProductsFetched] = useState(false);
  const [flexiblesFetched, setFlexiblesFetched] = useState(false);
  const [newSpecificationSaved, setNewSpecificationSaved] = useState(false);
  const [newSpecificationSavedId, setNewSpecificationSavedId] = useState();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [flexibles, setFlexibles] = useState(null);
  const [crimping, setCrimping] = useState(null);
  const [form] = Form.useForm();

  console.log(crimping, 'certissage');

  function getPredicat(diameter, name) {
    let predicat = parseInt(name?.attributes[0]?.options[0], 10) === diameter;
    if (diameter === 50 || diameter === 51) {
      predicat = parseInt(name?.attributes[0]?.options[0], 10) === 50 || parseInt(name?.attributes[0]?.options[0], 10) === 51;
    }
    if (diameter === 65 || diameter === 63) {
      predicat = parseInt(name?.attributes[0]?.options[0], 10) === 65 || parseInt(name?.attributes[0]?.options[0], 10) === 63;
    }
    return predicat;
  }
  const getFlexibleOptions = (prod) => {
    let codes = [];
    const flexibleFromForm = filteredFlexibleFeatures.filter(element => element !== undefined);
    flexibleFromForm.forEach(feature => {
      codes.push(JSON.parse(feature.productsCodes).codes);
    });
    codes = _.flatten(codes);
    prod?.data.map(p => console.log((_.filter(p?.meta_data, { key: 'code' })[0].value)));
    const flexible = prod?.data.filter(product => codes.includes(_.filter(product?.meta_data, { key: 'code' })[0].value)
      && _.filter(product?.meta_data, { key: 'stock_bonnes_pratiques_' })[0].value === 'oui'
      && getPredicat(specification.diameter, product));
    setFilteredProducts(flexible);

    const flexibleOptions = flexible.map(product => ({ key: product.id, value: product.id, label: product.name }));
    setFlexibles(flexibleOptions);
    setFlexiblesFetched(true);
  };

  useEffect(async () => {
    if (!_.isEmpty(recipe) && !newRecipeSaved) {
      let newRecipe = {};
      // eslint-disable-next-line react/prop-types
      if (!recipe?.id) {
        newRecipe = await saveRecipe(recipe);
        if (newRecipe?.data?.createFormula?.id) {
          await setNewRecipeSaved(true);
        }
      }
      // eslint-disable-next-line react/prop-types
      const incomingRecipe = !recipe.id ? newRecipe?.data?.createFormula : recipe;
      if (!_.isEmpty(specification)) {
        // eslint-disable-next-line react/prop-types
        if (!specification?.id) {
          const newSpecification = await saveSpecification(incomingRecipe, specification);
          if (!_.isEmpty(newSpecification?.data?.createRequirement?.id)) {
            setNewSpecificationSaved(true);
            setNewSpecificationSavedId(newSpecification?.data?.createRequirement?.id);
          }
        }
      }
      WoocommerceAPi.get('products', { per_page: 99, category: 146 })
        .then((woocommerceProducts) => {
          getFlexibleOptions(woocommerceProducts);
          WoocommerceAPi.get('products', { per_page: 10, category: 189 })
            .then((cert) => {
              setCrimping(cert?.data[0]);
              setProductsFetched(true);
            })
            .catch(err => {
              console.error(err);
            });
        })
        .catch(err => {
          console.error(err);
        });
    }
  }, []);

  const onFinish = (values) => {
    const chosenProduct = filteredProducts.filter(p => p.id === values.productId);
    return (replace('/proposal', {
      flexible: values, specification, recipe, chosenProduct, newSpecificationSavedId, crimping
    }));
  };

  const getFormOrSpinner = () => {
    if (crimping === null) {
      return <Spinner size="large" />;
    }
    return (
      <Form
        form={form}
        onFinish={onFinish}
        layout="horizontal"
        style={{ width: '100%' }}
      >
        <Form.Item
          required
          name="productId"
          label="Flexibles"
          labelAlign="left"
          rules={[
            {
              required: true,
              message: 'Champs requis',
            },
          ]}
        >
          <Select style={{ width: '100%' }} options={flexibles} />
        </Form.Item>
        <Row justify="center">
          <Space wrap align="start" size="large" style={{ marginTop: '20px' }}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item>
                <Button type="primary" htmlType="submit" icon={<CheckOutlined />}>
                  Valider le flexible
                </Button>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item>
                <Button
                  onClick={() => setFinalSpecifications(true)}
                  icon={<StopOutlined />}
                >
                  Annuler ma demande de chiffrage
                </Button>
              </Form.Item>
            </Col>
          </Space>
        </Row>
      </Form>
    );
  };

  const getContentOrSpinner = () => {
    if (!flexiblesFetched) {
      return <Spinner size="large" />;
    }
    return (
      <Result
        status="success"
        title="Les informations nous permettent de vous proposer un chiffrage en ligne"
        subTitle="Sélectionner un flexible parmis les modèles proposé afin de lancer le chiffrage"
        extra={(
          <Row justify="center">
            {getFormOrSpinner()}
          </Row>
        )}
      />
    );
  };

  const getWaitingTreatmentMessage = () => {
    if (flexiblesFetched) return false;
    return (
      <Title
        type="warning"
        style={{ marginBottom: '40px' }}
      >
        Nous traitons votre demande
        {' '}
        <LoadingOutlined />
      </Title>
    );
  };

  return (
    <>
      <Row justify="center">
        {getWaitingTreatmentMessage()}
        <Steps progressDot>
          {newRecipeSaved && (
            <Step title="Recette" description="Enregistré" status="finish" disabled />
          )}
          {newSpecificationSaved && (
            <Step title="Cahier des charges" description="Enregistrée" status="finish" disabled />
          )}
          {productsFetched && (
            <Step title="Produis" description="Chargés" status="finish" disabled />
          )}
          {flexiblesFetched && (
            <Step title="Flexibles" description="Chargés" status="finish" disabled />
          )}
        </Steps>
      </Row>
      <Row justify="center">
        {getContentOrSpinner()}
      </Row>
    </>
  );
};

CostingForm.propTypes = {
  recipe: PropTypes.shape({}),
  specification: PropTypes.shape({
    diameter: PropTypes.number
  }),
  filteredFlexibleFeatures: PropTypes.arrayOf(PropTypes.shape({})),
  history: PropTypes.shape({
    replace: PropTypes.func
  }),
  setFinalSpecifications: PropTypes.func,
};

export default CostingForm;
